import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { API } from '@/App';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          throw new Error('No session ID found');
        }

        const response = await fetch(`${API}/auth/session`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'X-Session-ID': sessionId,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to create session');
        }

        const data = await response.json();
        localStorage.setItem('token', data.session_token);
        
        toast.success('Successfully signed in!');
        navigate('/dashboard', { state: { user: data.user }, replace: true });
      } catch (error) {
        toast.error('Authentication failed. Please try again.');
        navigate('/auth', { replace: true });
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-600 via-indigo-600 to-purple-700">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg font-medium">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;